(function () {
  "use strict";

  AddNewUserCtrl.$inject = ['$scope', 'usersResource', '$routeParams', 'textLengthIndicatorState', 'authView', '$rootScope', 'mtypes', 'modalHelper', 'accountFeatures', 'actionLogResource', '$location', 'notificationService', '$timeout', 'trainerPrivilege', 'accountInfoService', 'hqTypes'];
  angular
    .module('trainerWebApp.controllers')
    .controller('AddNewUserCtrl', AddNewUserCtrl);

  function AddNewUserCtrl($scope, usersResource, $routeParams, textLengthIndicatorState, authView, $rootScope, mtypes,
                          modalHelper, accountFeatures, actionLogResource, $location, notificationService, $timeout,
                          trainerPrivilege, accountInfoService, hqTypes) {

    $scope.groupRestrictionTypes = {
      accessAllUsers: 'accessAllUsers',
      restrictedToGroups: 'restrictedToGroups'
    };

    $scope.seriesId = $routeParams.seriesId;
    $scope.courseId = $routeParams.courseId;
    var userRole = trainerPrivilege.roles();

    if (!userRole.canInviteUsers) {
      if ($scope.courseId)
        $location.path('/TMS/Distribute_Course/' + $scope.courseId + '/trainees');
      else if ($scope.seriesId)
        $location.path('/TMS/Series/' + $scope.seriesId + '/trainees');
      else
        $location.path('/TMS/ManageUsers');
    }

    var self = this; // for testing
    var pageLocation = getPageLocation($routeParams);
    $scope.makeCourseRequired = true;

    // TODO - once we create a text length directive, pull this out along with the bits below.
    var textLengthLookup = {
      firstName: 35,
      lastName: 35,
      email: 254,
      username: 50,
      password: 35
    };

    $scope.userModel = createUserModel();

    if(authView.isTrial() || authView.isInFeatureTrial())
      notificationService.setNotification({message:'Trainer Access Levels is only available on the Pro plan.', pageToShow: 'ManageUsers/addNewUser'});

    $scope.resetGroupRestrictions = function() {
      $scope.userModel.groupRestrictions = null;
      $scope.viewModel.showGroupRestrictions = getGroupRestrictionsVisibility();
      $scope.viewModel.groupRestrictionType = $scope.groupRestrictionTypes.accessAllUsers;
    };

    $scope.courseStatus = $scope.resolvedData.courseStatus;

    $scope.customFields = $scope.resolvedData.customFields;
    setupCustomFields();

    var emails = _.map($scope.resolvedData.emails, function (email) {
      return email.toLowerCase();
    });

    $scope.allGroups = _.map($scope.resolvedData.groups, function (value) {
      return { id: value.id, text: value.name }
    });

    $scope.restrictedGroups = $scope.allGroups;

    $scope.showPermissionsPreview = !~accountFeatures.features.indexOf(mtypes.featureEntry.trainerPermissions);

    function filterSampleCourse(courses){
      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.trainerHTMLHome)) {
        return _.filter(courses, function(item){ return item.id != mfConfig.sampleCourseId; });
      }

      return courses;
    }

    var allCourses = {
      courses: _.map(filterSampleCourse($scope.resolvedData.courses), function (value) {
        return { id: value.id, text: value.name, type: mtypes.courseType.online }
      })
    };
    var usernames = _.map($scope.resolvedData.usernames, function (username) {
      return username.toLowerCase();
    });
    // this is redundant need to refactor out but because the courses call
    // changed we need to add in the allCourses

    var currentState = initialView;
    var previousState = currentState;

    var restirctedEmails = _.map($scope.resolvedData.restrictedUsers, function (email) {
      return (email || "").toLowerCase();
    });

    var restirctedUsernames = _.map($scope.resolvedData.restirctedUsernames, function (usernames) {
      return (usernames || "").toLowerCase();
    });

    $scope.viewModel = {
      pageLocation: pageLocation.id,
      currentState: 'initial',
      showCourses: !_.isEmpty(allCourses.courses),
      showGroups: true,
      selects: getListOfRolesCurrentUserCanAdd(),
      isSeries: pageLocation.id === 'series',
      duplicateEmail: false,
      duplicateEmailMessage: "Duplicate email found.",
      userAdded: false,
      showRoleSelection: pageLocation.id === 'manage' && !_.isEmpty(getListOfRolesCurrentUserCanAdd()),
      showGroupRestrictions: getGroupRestrictionsVisibility(),
      groupRestrictionType: $scope.groupRestrictionTypes.accessAllUsers,
      duplicateUsername: false,
      duplicateUsernameMessage: "Duplicate username found."
    };

    $scope.selectGroupsOptions = {
      width: 'off',
      closeOnSelect: false,
      maximumInputLength: 40,
      clearOnSelect: true
    };

    setupCourseSeriesDropdown(allCourses);

    setupGroupRestrictionDropDown();

    $scope.updateInfo = function (model) {
      if (!validateUserModel(model))
        return;

      if(!validateGroupRestrictions()) {
        modalHelper.messageBox({
          title: 'Unable to add user',
          message: 'Choose at least one group for the user to manage'
        });
        return;
      }

      if(model.password && model.password.length < 6) {
        modalHelper.messageBox({
          title: 'Unable to add user',
          message: 'Password must be a minimum of 6 characters'
        });
        return;
      }

      if (mfConfig.useGroupRestrictions && (!model.groups || model.groups.length == 0)){
        modalHelper.messageBox({
          title: 'Trainees require group membership',
          message: 'You must add the trainee(s) to a group you manage'
        });
        return;
      }

      setCurrentState(pendingView);

      var dto = createDto(model);

      usersResource.importNewUsers(
        dto,
        function (result) {
          if(result && result.warnings && result.warnings.length > 0){
            modalHelper.messageBox({
              title: hqTypes.Errors.SyncFailure.Title,
              message: hqTypes.Errors.SyncFailure.Message,
              buttons: [{label: 'OK'}]
            });
          }
          setCurrentState(addAnotherView);
          var notification;
          if($scope.seriesId){
            notification = {message: '1 course invitation sent.', pageToShow: 'Series', close: true, displayOrder: 2};
            notificationService.setNotification(notification);
            $timeout(function() {
              notificationService.removeNotification(notification);
            }, 5000);
          }
          else if($scope.courseId){
            notification = $scope.courseStatus.status == 107000100 ?
              {message: '1 course invitation will be sent once the course is activated.', pageToShow: 'Course', close: true, displayOrder: 2} :
              {message: '1 course invitation sent.', pageToShow: 'Course', close: true, displayOrder: 2};
            notificationService.setNotification(notification);
            $timeout(function() {
              notificationService.removeNotification(notification);
            }, 5000);
          }
        },
        function (err) {
          setCurrentState(errorView);
          var message = 'There was an error adding the user. Please try again.';
          if (err && err.data && err.data.message)
            message = err.data.message;
          modalHelper.messageBox({title: 'Error Adding User', message: message, buttons: [{label: 'OK'}]});

          return "cancelDefault";
        });
    };

    $scope.resetInfo = resetInfo;

    $scope.clearAllGroups = function () {
      $scope.userModel.groups = null;
    };

    $scope.clearAllCourses = function () {
      $scope.userModel.courses = null;
    };

    $scope.getBackUrl = function () {
      return pageLocation.url;
    };

    $scope.roleSelectionChanged = function () {
      // fragile to check for 1 but it is necessary for right now
      $scope.viewModel.showCourses = !_.isEmpty(allCourses.courses) && $scope.userModel.permissions == '1';
      $scope.clearAllCourses();
      $scope.resetGroupRestrictions();

      if (!isTrainee() && !$scope.userModel.email) {
        formFieldValidityCache["email"].dataValid = false;
        $scope['emailStyle'] = 'redBorder';
      }
      else {
        formFieldValidityCache["email"].dataValid = true;
        $scope['emailStyle'] = '';
      }

      $scope.form.valid = calcFormValidity();
    };

    $scope.$watch('userModel.groups', function () {
      $scope.form.valid = calcFormValidity();
      $scope.form.dirty = calcFormDirty();
    });

    $scope.$watch('userModel.courses', function () {
      $scope.form.valid = calcFormValidity();
      $scope.form.dirty = calcFormDirty();
    });

    $scope.$watch('userModel.groupRestrictions', function () {
      if(!_.isEmpty($scope.userModel.groupRestrictions))
        $scope.viewModel.groupRestrictionType = $scope.groupRestrictionTypes.restrictedToGroups;

      $scope.form.valid = calcFormValidity();
      $scope.form.dirty = calcFormDirty();
    });

    $scope.$watch('viewModel.groupRestrictionType', function () {
      $scope.form.valid = calcFormValidity();
      $scope.form.dirty = calcFormDirty();
    });

    function setupCourseSeriesDropdown(allCourses) {
      var data = allCourses.courses;

      $scope.selectCoursesOptions = {
        width: 'off',
        data: data,
        closeOnSelect: false
      };
    }

    function setupGroupRestrictionDropDown() {
      $scope.resetGroupRestrictions();
      $scope.selectGroupRestrictionOptions = {
        width: 'none',
        closeOnSelect: false,
        data: $scope.userModel.groupRestrictions,
        clearOnSelect: true
      };
    }

    function getPageLocation(routeParams) {
      var type = {};
      if (routeParams.courseId) {
        type.id = 'course';
        type.url = "#/TMS/Distribute_Course/" + routeParams.courseId + "/trainees";
      } else if (routeParams.seriesId) {
        type.id = 'series';
        type.url = "#/TMS/Series/" + routeParams.seriesId + "/trainees";
      } else {
        type.id = 'manage';
        type.url = '#/TMS/ManageUsers/';
      }
      return type;
    }

    function validateUserModel(model) {
      // first and last are required
      if (!model.firstName || !model.lastName) {
        return false;
      }

      // email required for all non-trainees
      if (!isTrainee() && !model.email) {
        return false;
      }

      // trainees must have an email, or a username and a password
      if (isTrainee() && !(model.email || (model.username && model.password))) {
        return false;
      }

      return true;
    }

    function resetInfo() {
      resetUserEnrollment();
      resetUserModel();
      resetForm();
      resetStates();
    }

    function createUserModel() {
      return {
        firstName: null,
        lastName: null,
        email: null,
        permissions: '1',
        groups: null,
        courses: null,
        allGroups: null
      };
    }

    function createDto(model) {
      var courseIds = model.courses;

      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      var user = {
        firstName: model.firstName,
        lastName: model.lastName,
        email: model.email || undefined,
        permissions: _.isEmpty($scope.viewModel.selects) ? mtypes.userRole.trainee :
          _.find($scope.viewModel.selects,function (value) {
            return value.id == model.permissions;
          }).permission,
        username: model.username || undefined,
        password: model.password || undefined
      };

      _.each($scope.customFields, function (field) {
        if (!$scope.userModel[field.fieldName]) return;
        user[field.fieldName] = $scope.userModel[field.fieldName];
      });

      return {
        users: [user],
        requiredCourseIds: $scope.getRequiredCourseIds(courseIds),
        courseIds: pageLocation.id == 'series' ? [$routeParams.seriesId] : _.pluck(courseIds, 'id'),
        groupIds: _.pluck(model.groups, 'id'),
        groupRestrictionIds: _.pluck(model.groupRestrictions, 'id'),
        clientDatestamp: dateString
      }
    }

    $scope.getRequiredCourseIds = function (courseIds) {
      if(courseIds && courseIds.length && $scope.makeCourseRequired)
        return _.pluck(courseIds, 'id');

      // check series first since required is on by default
      if (!$scope.makeCourseRequired)
        return [];
      if ($routeParams.seriesId)
        return [$routeParams.seriesId];
      if (!$routeParams.courseId)
        return [];

      return [$routeParams.courseId];
    };

    function resetUserModel() {
      _.each($scope.userModel, function (value, key) {
        $scope.userModel[key] = null;
      });
      $scope.userModel.permissions = '1';

      $scope.resetGroupRestrictions();
    }

    function resetUserEnrollment() {
      $scope.userModel.groups = null;
      $scope.userModel.courses = null;
    }

    function createForm() {
      return {
        valid: true,
        dirty: false,
        showPasswordHint: false
      };
    }

    function resetForm() {
      $scope.form.valid = true;
      $scope.form.dirty = false;
    }

    function resetStates() {
      textLengthIndicatorState.resetStates();
      formFieldValidityCache = getFormFieldValidityCache(textLengthLookup, $scope.userModel);
      _.each(formFieldValidityCache, function (value, key) {
        applyFormState(key, formFieldValidityCache[key]);
      });
    }

    function setCurrentState(func) {
      (currentState = func)(arguments.length > 1 ? arguments[1] : undefined);
    }

    function initialView() {
    }

    function pendingView() {
      $rootScope.$broadcast('$showLoadingSpinner', true);
    }

    function addAnotherView() {
      $rootScope.$broadcast('$showLoadingSpinner', false);
      $scope.viewModel.userAdded = true;
      resetUserModel();
      resetForm();
      resetStates();
    }

    function errorView() {
      $rootScope.$broadcast('$showLoadingSpinner', false);
    }

    function getGroupRestrictionsVisibility() {
      var hasFeatureTurnedOn = authView.showUserPermissionsManagement();
      var hasCompatibleRole = $scope.userModel.permissions == '2' /*Reporter*/ ||
        $scope.userModel.permissions == '3' /*Team Lead*/ ||
        $scope.userModel.permissions == '4' /*Manager*/ ||
        $scope.userModel.permissions == '5' /*Trainer*/;

      return hasFeatureTurnedOn &&
          hasCompatibleRole;
    }

    var storedUserInfo = {};
    var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
    var formFieldValidityCache = getFormFieldValidityCache(textLengthLookup, $scope.userModel);

    $scope.form = createForm();

    $scope.onFormFieldFocus = function (key) {
      applyFormState(key, formFieldValidityCache[key]);
      if (key === 'password') {
        $scope.form.showPasswordHint = true
      }
    };

    $scope.onFormFieldInputBlur = function (key) {
      if (key === 'password' && !$scope.addUser.password.$viewValue) {
        $scope.form.showPasswordHint = false;
      }

      var state = formFieldValidityCache[key];
      if (!state.lengthValid || !state.dataValid)
        return;

      applyFormState(key, textLengthIndicatorState.defaultState);
    };

    $scope.validateFormTextLength = function (key) {
      $timeout(function() {
        validateFormTextLength(key);
      });
    };

    function validateFormTextLength(key) {
      doValidateFormTextLength(key);

      $scope.form.valid = calcFormValidity() && validateUserModel($scope.userModel);
      $scope.form.dirty = calcFormDirty();
    }

    function doValidateFormTextLength(key) {
      if (!key) return;
      var text = $scope.userModel[key];
      var state = {};

      if (key === 'email')
        state = getEmailState();
      else if (key === 'username')
        state = getUsernameState();
      else if (key === 'password')
        state = getPasswordState();
      else
        state = textLengthIndicatorState.getState(text, textLengthLookup[key]);

      applyFormState(key, state);
      formFieldValidityCache[key] = state;
    }

    function applyFormState(key, state) {
      $scope[key + 'IndicatorStyle'] = state.style;
      $scope[key + 'IndicatorText'] = state.text;
      $scope[key + 'Style'] = state.dataValid ? '' : 'redBorder';
    }

    var calcFormValidity = self.calcFormValidity = function () {
      if (!validateUserModel($scope.userModel) ||
        !validateGroupRestrictions())
        return false;

      for (var key in formFieldValidityCache) {
        switch (key) {
          case 'password':
            formFieldValidityCache[key] = getPasswordState();
            break;
          case 'username':
            formFieldValidityCache[key] = getUsernameState();
            break;
          case 'email':
            formFieldValidityCache[key] = getEmailState();
            break;
        }

        if (!formFieldValidityCache[key].lengthValid || !formFieldValidityCache[key].dataValid) {
          return false;
        }
      }
      return true;
    };

    function calcFormDirty() {
      if (!_.isEmpty($scope.userModel.groups) ||
        !_.isEmpty($scope.userModel.courses) ||
        hasGroupRestrictions()) {
        return true;
      }
      for (var key in formFieldValidityCache) {
        if ($scope.userModel[key] && $scope.userModel[key].trim() !== storedUserInfo[key]) {
          return true;
        }
      }
      return false;
    }

    function validateGroupRestrictions() {
      if($scope.viewModel.groupRestrictionType === $scope.groupRestrictionTypes.restrictedToGroups
          && (!$scope.userModel.groupRestrictions || $scope.userModel.groupRestrictions.length === 0))
        return false;

      return true;
    }

    function hasGroupRestrictions() {
      return !_.isEmpty($scope.userModel.groupRestrictions) && $scope.viewModel.groupRestrictionType === $scope.groupRestrictionTypes.restrictedToGroups;
    }

    function getFormFieldValidityCache(textLengthKeys, model) {
      var obj = {};
      for (var key in textLengthLookup) {
        if (key === 'password') {
          obj[key] = getPasswordState();
          continue;
        }
        if(key === 'username') {
          obj[key] = getUsernameState();
          continue;
        }
        if(key === 'email') {
          obj[key] = getEmailState();
          continue;
        }

        obj[key] = textLengthIndicatorState.getState($scope.userModel[key], textLengthLookup[key]);
      }
      return obj;
    }

    $scope.getIndicatorStyle = function (name) {
      return $scope[name + 'IndicatorStyle'];
    };

    $scope.getIndicatorText = function (name) {
      return $scope[name + 'IndicatorText'];
    };

    $scope.getFieldStyle = function (name) {
      return $scope[name + 'Style'];
    };

    $scope.showFeatureUpgrade = function() {
      accountInfoService.openNewWindow();
    };

    function getListOfRolesCurrentUserCanAdd() {
      var ret = [];
      var arr = authView.getListOfRolesCurrentUserCanAdd();
      if(!arr.length && authView.isAdministrator()) arr = [mtypes.userRole.trainee];
      var lookup = getRoleLookup();
      var item;

      for (var i = 0; i < arr.length; i++) {
        item = lookup[arr[i]];
        ret.push({
          'id': (i + 1).toString(),
          'name': item.name,
          'tip': item.tip,
          'permission': arr[i]
        });
      }
      return ret;
    }

    function getRoleLookup() {
      var lookup = {};
      lookup[mtypes.userRole.trainee] = {
        name: 'Trainee',
        tip: 'Trainees can take courses but have no administrative access.'
      };
      lookup[mtypes.userRole.reporter] = {
        name: 'Reporter',
        tip: 'Reporters can view and download reports and certificates.'
      };
      lookup[mtypes.userRole.teamLead] = {
        name: 'Team Lead',
        tip: 'Team Leads can view reports and manage users. They cannot add, invite or drop trainees.'
      };
      lookup[mtypes.userRole.manager] = {
        name: 'Manager',
        tip: 'Managers can view reports and manage trainees.'
      };
      lookup[mtypes.userRole.trainer] = {
        name: 'Trainer',
        tip: 'Trainers can create and edit courses, view reports and manage trainees.'
      };
      lookup[mtypes.userRole.administrator] = {
        name: 'Administrator',
        tip: 'Administrators have full access to all account features and users.'
      };
      return lookup;
    }

    function setupCustomFields() {
      _.each($scope.customFields, function (field) {
        var fieldName = 'customField' + field.fieldIndex;

        $scope.userModel[fieldName] = null;

        textLengthLookup[fieldName] = 200;

        field.fieldName = fieldName;
        field.indicatorStyle = fieldName + 'IndicatorStyle';
        field.style = fieldName + 'Style';

        $scope[fieldName + 'IndicatorStyle'] = '';
        $scope[fieldName + 'IndicatorText'] = '';
        $scope[fieldName + 'Style'] = '';
      });
    }

    /**
     * Password, username and email rules
     */
    function getPasswordState() {
      var key = 'password';
      var passwordText = $scope.userModel[key];
      // initial load
      if ($scope.addUser && $scope.addUser.password && !$scope.addUser.password.$viewValue) {
        return {lengthValid: true, dataValid: true};
      }

      if ($scope.addUser && $scope.addUser.password && $scope.addUser.password.$viewValue) {
        return {
          lengthValid: !$scope.addUser.password.$error.passwordLen,
          dataValid: $scope.addUser.password.$valid
        };
      }

      return {lengthValid: true, dataValid: true};
    }

    function getUsernameState() {
      var key = 'username';
      var usernameText = $scope.userModel[key];
      $scope.viewModel.duplicateUsername = false;
      // initial load
      if(usernameText === undefined || usernameText === null)
        return  {lengthValid: true, dataValid: true};

      var state = textLengthIndicatorState.getState(usernameText, textLengthLookup[key]);

      if (traineeWithoutEmail() && valueMissing(key))
        return state;


      var isDuplicateUsername = _.contains(usernames, usernameText.toLowerCase());

      if (isDuplicateUsername && mfConfig.useGroupRestrictions && !_.contains(restirctedUsernames, usernameText.toLowerCase())){
        $scope.viewModel.duplicateUsernameMessage = "Trainee already exists. Contact the administrator at <a href='mailto:" + mfConfig.ownerEmail +"'>" + mfConfig.ownerEmail + "</a> for access.";
        if (!$scope.viewModel.duplicateUsername){
          actionLogResource.writeActionLog([
            {
              action: mtypes.actionType.restrictedUserAdditionAttempted,
              metadata1: usernameText
            }
          ]);
        }
      } else {
        $scope.viewModel.duplicateUsernameMessage = "Duplicate username found.";
      }

      if (isDuplicateUsername){
        $scope.viewModel.duplicateUsername = true;
        state.dataValid = false;
        return state;
      }

      return  {lengthValid: true, dataValid: true};
    }

    function getEmailState() {
      var key = 'email';
      $scope.viewModel.duplicateEmail = false;
      var emailText = $scope.userModel[key];
      // initial load
      if(emailText === undefined || emailText === null || emailText === "")
        return  {lengthValid: true, dataValid: true};

      var isValidEmail = emailRegex.test(emailText);
      var isDuplicateEmail = _.contains(emails, emailText.toLowerCase());

      if (isDuplicateEmail && mfConfig.useGroupRestrictions && !_.contains(restirctedEmails, emailText.toLowerCase())) {
        $scope.viewModel.duplicateEmailMessage = "Trainee already exists. Contact the administrator at <a href='mailto:" + mfConfig.ownerEmail +"'>" + mfConfig.ownerEmail + "</a> for access.";
        if (!$scope.viewModel.duplicateEmail) {
          actionLogResource.writeActionLog([
            {
              action: mtypes.actionType.restrictedUserAdditionAttempted,
              metadata1: emailText
            }
          ]);
        }
      } else {
        $scope.viewModel.duplicateEmailMessage = "Duplicate email found.";
      }

      $scope.viewModel.duplicateEmail = isDuplicateEmail;
      // trainee with a username
      if(isTrainee() && !valueMissing('username')) {
        if (valueMissing('email'))
          return  {lengthValid: true, dataValid: true};
        else
          return {lengthValid: true, dataValid: isValidEmail && !isDuplicateEmail};
      }

      var state = textLengthIndicatorState.getState(emailText, textLengthLookup[key]);

      // email is required for non-trainees
      if(!isTrainee() && valueMissing('email'))
        return state;

      // email is required when a trainee lacks a username
      if(traineeWithoutUsername() && valueMissing('email'))
        return state;

      // test valid email regex
      if(!isValidEmail) {
        state.dataValid = false;
        return state;
      }

      if(isDuplicateEmail) {
        state.dataValid = false;
        return state;
      }

      return  {lengthValid: true, dataValid: true};
    }

    function valueMissing(key) {
      return !$scope.userModel[key] || $scope.userModel[key].trim().length === 0;
    }

    function isTrainee() {
      return $scope.userModel.permissions == 1;
    }

    function traineeWithoutEmail() {
      return isTrainee() && valueMissing('email');
    }

    function traineeWithoutUsername() {
      return isTrainee() && valueMissing('username');
    }
  }

})();
